import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSelect from './CustomSelect/CustomSelect';
import { getCountriesAction } from '../store/location/asyncActions';

const CountrySelect = ({ value, onChange, error, helperText, disabled, required, user, ...props }) => {
    const dispatch = useDispatch();
    const { countries } = useSelector((state) => state.location);

    useEffect(() => {
        if (!countries.data && !countries.loading) {
            dispatch(getCountriesAction(user));
        }
    }, [dispatch, countries.data]);

    return (
        <CustomSelect
            title="Select Country"
            options={countries.data?.data || []}
            labelKey="country_name"
            value={value}
            onSelect={onChange}
            error={error}
            helperText={helperText}
            disabled={disabled || countries.loading}
            required={required}
            {...props}
        />
    );
};

export default CountrySelect;
